// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_e8b6867","title":"_d2c1827","description":"_31e7a1e"};